
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gVYmUq_JkWSLSVOz0YVJZCxjES_45pXTtGhYtf_RV0EMOgMeta } from "/codebuild/output/src2148080121/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexurDfotmprgCvNUXCz5IqPPQlQqAPvFr3mWW7RPMZzg0Meta } from "/codebuild/output/src2148080121/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchvveWzDyrwexwkjt_45ZRhF9KNIfKS9Iufr4StO9ZQDV24Meta } from "/codebuild/output/src2148080121/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexvdogx0mLYy56WzZqAmLZ7rdk0d81R9dRjy6ailM1tucMeta } from "/codebuild/output/src2148080121/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93Lt0ZjziMqwHFce_45RLP32bLFyyu0qbJoA6xPJ008lcbEMeta } from "/codebuild/output/src2148080121/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index5wR3ug7br30LdjqYiW1liQ5CBPlejmIM1bAu6uK6IR8Meta } from "/codebuild/output/src2148080121/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93rlIus_L9eOtw2uLK1c5Q4I60k2gI2nMFEWmk4yrAInUMeta } from "/codebuild/output/src2148080121/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexcoOS9JGykfsWkv5YndJkeXjBCTsbkNOlhxP9tC_7k90Meta } from "/codebuild/output/src2148080121/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93kRmhZNd4WgSM0xg_Tcd083cdgy7yQLD_45kUjaOhSsFTIMeta } from "/codebuild/output/src2148080121/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexjBNpTbpEqjPCt5sAgDcbkA_m4OQOG7lHn_45lssk07tJEMeta } from "/codebuild/output/src2148080121/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexoAIUlP4qbKnpZBsLkeZgnzGnP9DbdzLa3qTbkfglrW4Meta } from "/codebuild/output/src2148080121/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2148080121/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2148080121/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2148080121/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2148080121/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2148080121/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index5wR3ug7br30LdjqYiW1liQ5CBPlejmIM1bAu6uK6IR8Meta || {},
    component: () => import("/codebuild/output/src2148080121/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2148080121/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexcoOS9JGykfsWkv5YndJkeXjBCTsbkNOlhxP9tC_7k90Meta || {},
    component: () => import("/codebuild/output/src2148080121/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2148080121/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexjBNpTbpEqjPCt5sAgDcbkA_m4OQOG7lHn_45lssk07tJEMeta || {},
    component: () => import("/codebuild/output/src2148080121/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexoAIUlP4qbKnpZBsLkeZgnzGnP9DbdzLa3qTbkfglrW4Meta || {},
    component: () => import("/codebuild/output/src2148080121/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]